<template>
  <div class="white-rounded-box pl-7 pt-7 posts-wrapper mb-11">
    <div class="flex justify-between items-center mr-9 mb-5">
      <h2>Pinned Pings</h2>
      <div class="flex items-center">
        <button @click.prevent="toggleFilterDropdown" type="button" title="Filter" class="mr-5">
            <svg-vue icon="filter-solid" class="h-5 w-5 fill-salesium-red" />
        </button>

        <button @click.prevent="onExpand" type="button" title="Expand" class="h-5 w-5">
          <svg-vue icon="maximize-solid" class="h-5 w-5 fill-salesium-red" />
        </button>
      </div>
    </div>

    <div class="mr-10 mb-3">
        <label
          for="ping-search"
          class="sr-only"
        >Search</label>
        <div class="relative">
          <form @submit.prevent="onSearch">
            <input
              id="ping-search"
              name="ping-search"
              class="block w-full py-2 pr-3 br-10 text-hint placeholder-grey-600 focus:text-gray-900 focus:placeholder-gray-500 border-custom-grey"
              placeholder="Search for a ping"
              type="search"
              v-model="search"
            />
            <button
              type="submit"
              title="Search"
              class="
                absolute
                inset-y-0
                right-0
                pl-3
                flex
                items-center
              "
            >
              <svg-vue icon="search" class="fill-salesium-red w-6 h-6 inline-block mr-3"
              title="Search" />
            </button>
          </form>
        </div>
      </div>

    <div class="all-posts-container mb-11">
      <Post
        v-for="(post, i) in posts"
        :post="post"
        :key="i"
        :includePin="true"
        v-on:togglePin="togglePostPin"
      />
    </div>
  </div>
</template>

<script>
import Post from '../../Utils/Post.vue';
import FilterButton from '../../Utils/FilterButton.vue';
export default {
    props: ['posts'],
    data() {
        return {
            search: '',
        }
    },
    methods: {
        async onSearch() {
            // TODO: implement searching through pinned posts
        },
        togglePostPin(event) {
            // TODO: switch posts pin status
        },
        toggleFilterDropdown() {
            // TODO: handle showing filters
        },
        onExpand() {
            // TODO: handle expanding, more details needed
        }
    },
    components: {
        Post,
        FilterButton,
    },
};
</script>

<style scoped>
::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    border-radius: 10px;
}

::-webkit-scrollbar-track {
    width: 10px;
    border-radius: 10px;
}
</style>
